// extracted by mini-css-extract-plugin
export var externalLink = "_9y-0";
export var internalLinkLabel = "_9y-1";